import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import ActionButton from "@/components/base/ActionButton";
import { technologyCards } from "@/mocks/technology";

export default function TechnologySection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-container px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="EV Technology"
            title="The Technology Behind an Electric Retrofit"
            description="Retrofit engineering brings together powertrain, energy storage, control and safety systems. Component selection is always matched to the vehicle and configuration — no universal technical figures are published here."
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {technologyCards.map((item, index) => (
            <Reveal key={item.key} delay={index * 0.04}>
              <article className="h-full rounded-lg border border-background-200 bg-background-50 p-6 transition-colors duration-300 hover:border-primary-300">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-800">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <h3 className="mt-4 text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {item.description}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10">
            <ActionButton to="/technology" variant="dark" size="md" iconRight="ri-arrow-right-line">
              See Full Technology Stack
            </ActionButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}